import _each from "lodash/each";

function reset(identifier) {
    const container = $('.group-configurable-' + identifier);
    if (container.length > 0) {
        $('input.product-option-items[data-disabled]', container).prop('disabled', false).removeAttr('data-disabled');
        $('select option', container).prop('disabled', false).removeAttr('data-disabled').trigger('change.select2');
        $('.group-content', container).removeClass('group-hidden');
    }
    resetMedia();
}

function handle(identifier, dependencies) {
    reset(identifier);
    _each(dependencies ?? [], (dependency) => {
        if (dependency.action === 'disable') {
            handleDisable(dependency)
        }
        if (dependency.action === 'switchMedia') {
            handleSwitchMedia(dependency);
        }
        if (dependency.action === 'select') {
            handleSelect(dependency);
        }
    });
}

function handleDisable(dependency) {
    switch (dependency.type) {
        case 'product-option':
            // input fields
            let inputItems = $('input.product-option-items[value="' + dependency.parameters.id + '"]');
            inputItems.prop('disabled', true).attr('data-disabled', 1);

            // select fields
            let selectItems = $('select.product-option-items option[value="' + dependency.parameters.id + '"]');
            if (selectItems.is(':selected')) {
                let select = selectItems.closest('select');
                $('option', select).each(function () {
                    if ($(this).val() != dependency.parameters.id) {
                        // select first
                        select.val($(this).val()).trigger('change');
                        return false;
                    }
                });
            }
            selectItems.prop('disabled', true).attr('data-disabled', 1);
            break;
        case 'option-group':
            if (dependency.parameters.group) {
                $('.group-content[data-group="' + dependency.parameters.group + '"]').addClass('group-hidden');
            }
            break;
    }

}

function handleSelect(dependency) {
    switch (dependency.type) {
        case 'product-option':
            // input fields
            $('input.product-option-items[value="' + dependency.parameters.id + '"]').trigger('click');

            // select fields
            let selectItems = $('select.product-option-items option[value="' + dependency.parameters.id + '"]');
            if (selectItems.length > 0) {
                selectItems.closest('select').val(dependency.parameters.id);
            }
            break;
        case 'option-group':
            break;
    }
}

function resetMedia() {
    let container = $('.product-info-container');
    if ($('a#gallery', container).attr('orig-src')) {
        let orig = $('a#gallery', container);
        if ($('a#gallery', container).hasClass('MagicZoomPlus')) {
            MagicZoom.update(document.querySelector('#gallery'), orig, orig);
        }
        if ($('a#gallery', container).hasClass('MagicThumb')) {
            MagicThumb.update(document.querySelector('#gallery'), orig, orig);
        }
        $('a#gallery', container).removeAttr('orig-src');
    }
}

function handleSwitchMedia(dependency) {
    if (dependency.parameters?.url) {
        let container = $('.product-info-container');
        if (!$('a#gallery', container).attr('orig-src')) {
            $('a#gallery', container).attr('orig-src', $('a#gallery', container).attr('src'));
        }
        if ($('a#gallery', container).hasClass('MagicZoomPlus')) {
            MagicZoom.update(document.querySelector('#gallery'), dependency.parameters.url, dependency.parameters.url);
        }
        if ($('a#gallery', container).hasClass('MagicThumb')) {
            MagicThumb.update(document.querySelector('#gallery'), dependency.parameters.url, dependency.parameters.url);
        }
    }
}

export default {reset, handle}
